/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface RtSystemScopeDto
 */
export interface RtSystemScopeDto {
    /**
     * 
     * @type {string}
     * @memberof RtSystemScopeDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RtSystemScopeDto
     */
    rtSystemCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RtSystemScopeDto
     */
    rtSystemSubCategory?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RtSystemScopeDto
     */
    readonly name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RtSystemScopeDto
     */
    manufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RtSystemScopeDto
     */
    model?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RtSystemScopeDto
     */
    $type?: RtSystemScopeDtoTypeEnum;
}


/**
 * @export
 */
export const RtSystemScopeDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoScopesRtSystemScopeDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.Scopes.RtSystemScopeDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type RtSystemScopeDtoTypeEnum = typeof RtSystemScopeDtoTypeEnum[keyof typeof RtSystemScopeDtoTypeEnum];



/**
 * Check if a given object implements the RtSystemScopeDto interface.
 */
export function instanceOfRtSystemScopeDto(value?: unknown): value is RtSystemScopeDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(RtSystemScopeDtoTypeEnum)[0];
}

export function RtSystemScopeDtoFromJSON(json: any): RtSystemScopeDto {
    return RtSystemScopeDtoFromJSONTyped(json, false);
}

export function RtSystemScopeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RtSystemScopeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'rtSystemCategory': json['rtSystemCategory'] == null ? undefined : json['rtSystemCategory'],
        'rtSystemSubCategory': json['rtSystemSubCategory'] == null ? undefined : json['rtSystemSubCategory'],
        'name': json['name'] == null ? undefined : json['name'],
        'manufacturer': json['manufacturer'] == null ? undefined : json['manufacturer'],
        'model': json['model'] == null ? undefined : json['model'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function RtSystemScopeDtoToJSON(value?: Omit<RtSystemScopeDto, 'name'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'rtSystemCategory': value['rtSystemCategory'],
        'rtSystemSubCategory': value['rtSystemSubCategory'],
        'manufacturer': value['manufacturer'],
        'model': value['model'],
        '$type': value['$type'],
    });
}

